/*
 * @Author: EdwardYoung
 * @Date: 2017-07-31 19:57:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-08 19:42:18
 */
/**
 * 根据url判断是否在砍价后的订单页，
 * 若在，则替换下单按钮
 */
import axios from 'api/axios'
import {localstorageGetItem} from 'common/util/localstorageUtil'
import {createApiHeader} from 'api/createApiHeader.js'
import {modifyByEquipment} from 'common/util/modifyUIOfSubmitOrder'
import {pcOpts, phoneOpts} from 'common/util/orderUIConfig'

import {isFirstExecute} from 'common/util/isFirstExecute'

/**
 * 初始化提交订单页
 */
function initSubmitOrder () {
  (function (yhsd) {
    return yhsd.ready(function (sdk) {
      return sdk
        .events
        .subscribe('component.render.completed', function () {
          let _fn = isFirstExecute(function () {
            if (isLinkSubmitOrder()) {
              let bargainAmount = (getQueryString('bargainAmount') / 100).toFixed(2)
              modifyByEquipment(pcOpts, phoneOpts, bargainAmount)
              handleSubmitOrderClick()
            }
          })
          _fn()
        })
    })
  })(window.yhsd)
}

/**
 * 是否跳转到下单页
 */
function isLinkSubmitOrder () {
  let searchUrl = window.location.search
  if (searchUrl.indexOf('yhsd-play-mode-stage=order') !== -1) {
    return true
  } else {
    return false
  }
}

// 修改提交订单click触发函数
function handleSubmitOrderClick () {
  window.yhsdOverrideMobiOrderCreate = function (_order, next) {
    Jssdk.order.create(_order, function (data) {
      const campaignId = localstorageGetItem('campaignId')
      const orderId = data.res.order_id
      //  提交campaignId和orderId给改价接口，不必管是否回调
      submitOrder(campaignId, orderId).catch(err => {
        console.log(err)
      }).then(() => {
        next(data)
      })
    })
  }
}

/**
 * 向插件后台提交，触发改价
 * @param {活动id} id
 * @return {活动信息}
 */
async function submitOrder (campaignId, orderId) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _submitOrder(campaignId, orderId).then((res) => {
          resolve(res.data.data.updated)
        })
      })
    })
  })
}

//  向插件后台提交订单API
function _submitOrder (campaignId, orderId) {
  const activityUrl = `/v1/front/order/${orderId}`
  return axios({
    method: 'POST',
    url: activityUrl,
    data: {
      campaign_id: campaignId
    }
  })
}

function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

export {initSubmitOrder}



// WEBPACK FOOTER //
// ./src/common/util/initSubmitOrder.js